<div
    class="st-icon-container"
    st-assignment-icon
    [title]="title()"
    [data]="data()"
    [itemType]="type()"
    [hasValue]="hasValue()"
    [hasBorder]="hasBorder()"></div>
